import classes from "./ProductItem.module.less";
import { saveSearchTerm } from "~/Header/components/headerMenu/Autosuggest/api/saveSearchTerm";
import type { SrpProductData } from "~/utils/models";
import { forwardRef } from "react";
import { ProductContext } from "~/feature/Product/ProductContext";
import { Product } from "~/feature/Product";
import { SaleTag } from "~/SalesCampaign/components/SaleTag/SaleTag";
import { LinkType } from "~/common/components/Link";
import { useIsMinDesktopSizeM } from "~/common/hooks/useMediaQuery";

interface Props {
  className?: string;
  product: SrpProductData;
}

export const ProductItem = forwardRef<HTMLAnchorElement, Props>(({ product, className }: Props, ref) => {
  const hasSales = Object.keys(product.salesCampaign).length > 0;

  const linkProps = {
    onClick: () => saveSearchTerm(product.designation, `${product.url}?text=${product.designation}`),
    href: `${product.url}?text=${product.designation}`,
    ["tracking-aux-sch-prod-name"]: product.designation,
    ["tracking-aux-sch-prod-id"]: product.sapMaterialNumber,
    ["data-prod-article"]: product.hybrisCode,
  };

  const isDesktopM = useIsMinDesktopSizeM();

  return (
    <ProductContext value={product}>
      <div
        className={classes.root}
        asgsta-product-parent-marker="true"
        asgsta-is-campaign-belonging={`${hasSales}`}
        asgsta-campaign={Object.values(product.salesCampaign)[0]?.[0].code ?? "None"}
        data-zoovu="searchSuggestion"
      >
        {isDesktopM && <Product.PrimaryImage className={classes.image} linkProps={{ ...linkProps, tabIndex: -1 }} />}
        <div className={classes.designationContainer}>
          <Product.FullDesignation
            designationComponent={"span"}
            linkProps={{ ...linkProps, ref, variant: LinkType.NAVIGATION }}
          />
          {hasSales && <SaleTag size={16} />}
        </div>
        <Product.ShortDescription className={classes.description} linkProps={{ ...linkProps, tabIndex: -1 }} />
      </div>
    </ProductContext>
  );
});
